import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { DataLake } from "@graylog/enterprise-api";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES } from "../Constants";
const streamDataLakeConfigs = create({
  fetcher: (ids) => DataLake.getStreamConfigs({ stream_ids: ids }),
  resolver: keyResolver("stream_id"),
  scheduler: windowScheduler(10)
});
export const fetchStreamDataLakeConfig = (streamId) => fetch("GET", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.stream_data_lake_config(streamId).url));
const useStreamDataLakeConfig = (streamId) => {
  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: ["data-lake-config", streamId],
    queryFn: () => streamDataLakeConfigs.fetch(streamId),
    placeholderData: keepPreviousData,
    retry: 1
  });
  return {
    data,
    refetch,
    isFetching,
    isError
  };
};
export default useStreamDataLakeConfig;
